
const Factory = {

  Meta: {

    identity: ( slug ) => {
      return require( './meta/identity' ).default[ slug ];
    },

    domain: ( slug ) => {
      return require( './meta/domain' ).default[ slug ];
    },

    identity1: () => {
      return require( './meta/identity' ).default;
    },

    domain1: () => {
      return require( './meta/domain' ).default;
    }

  },

  Data: {

    identity: ( slug ) => {
      return require( './data/identity' ).default[ slug ];
    },

    domain: ( slug ) => {
      return require( './data/domain' ).default[ slug ];
    },

    identity1: () => {
      return require( './data/identity' ).default;
    },

    domain1: () => {
      return require( './data/domain' ).default;
    }

  },

};



export default Factory;